import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/**
 * Layout slot around a feed card. When `exiting`, the slot collapses its
 * height (and the stack gap) so remaining cards in the group slide together
 * instead of jumping after unmount.
 */
export function FeedRowSlot({
  exiting,
  children,
}: {
  exiting: boolean;
  children: ReactNode;
}) {
  return (
    <div
      className={cn("feed-row-slot", exiting && "feed-row-slot--exit")}
      aria-hidden={exiting || undefined}
    >
      <div className="feed-row-slot__clip">{children}</div>
    </div>
  );
}
